import api from '../utils/api';

/**
 * ดึงรายการใบแจ้งสินค้าค้างส่งทั้งหมด
 * @param {object} params - พารามิเตอร์การค้นหา { status, customer_name, start_date, end_date }
 * @returns {Promise}
 */
export const getPendingDeliveries = async (params = {}) => {
    try {
        const response = await api.get('/api/pending-deliveries', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching pending deliveries:', error);
        throw error;
    }
};

/**
 * ดึงข้อมูลใบแจ้งสินค้าค้างส่งตาม ID
 * @param {number} id - ID ของใบแจ้งสินค้าค้างส่ง
 * @returns {Promise}
 */
export const getPendingDeliveryById = async (id) => {
    try {
        const response = await api.get(`/api/pending-deliveries/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pending delivery:', error);
        throw error;
    }
};

/**
 * สร้างใบแจ้งสินค้าค้างส่งใหม่
 * @param {object} data - ข้อมูลใบแจ้งสินค้าค้างส่ง
 * @returns {Promise}
 */
export const createPendingDelivery = async (data) => {
    try {
        const response = await api.post('/api/pending-deliveries', data);
        return response.data;
    } catch (error) {
        console.error('Error creating pending delivery:', error);
        throw error;
    }
};

/**
 * อัพเดทใบแจ้งสินค้าค้างส่ง
 * @param {number} id - ID ของใบแจ้งสินค้าค้างส่ง
 * @param {object} data - ข้อมูลที่ต้องการอัพเดท
 * @returns {Promise}
 */
export const updatePendingDelivery = async (id, data) => {
    try {
        const response = await api.put(`/api/pending-deliveries/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating pending delivery:', error);
        throw error;
    }
};

/**
 * ลบใบแจ้งสินค้าค้างส่ง
 * @param {number} id - ID ของใบแจ้งสินค้าค้างส่ง
 * @returns {Promise}
 */
export const deletePendingDelivery = async (id) => {
    try {
        const response = await api.delete(`/api/pending-deliveries/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting pending delivery:', error);
        throw error;
    }
};

/**
 * อัพเดทจำนวนที่ส่งไปแล้ว
 * @param {number} id - ID ของใบแจ้งสินค้าค้างส่ง
 * @param {array} items - [{ item_id, delivered_quantity }]
 * @returns {Promise}
 */
export const updateDeliveredQuantity = async (id, items) => {
    try {
        const response = await api.put(`/api/pending-deliveries/${id}/update-delivered`, { items });
        return response.data;
    } catch (error) {
        console.error('Error updating delivered quantity:', error);
        throw error;
    }
};
